// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"575":"cefca6c7","743":"77c9f20a","824":"ab12a3c5"}[chunkId] + ".css";
};